import {ReactionApiModel} from '../../api/models/reaction.api.model';
import {createReactionListPageKey, ReactionListPageState, ReactionListsState} from './reaction-list.models';
import * as ReactionListActions from './reaction-list.actions';
import {ReactionListActionTypes} from './reaction-list.actions';

export const initialState: ReactionListsState = {
  pages: {}
};

function toIds(reactions: ReactionApiModel[]): string[] {
  return reactions.map((reaction) => reaction['@id']).filter((id): id is string => !!id);
}

function createPageState(ids: string[], hasMore: boolean, status: ReactionListPageState['status'], loadedAt: number | null): ReactionListPageState {
  return {
    ids,
    hasMore,
    status,
    loadedAt
  };
}

export function reactionListsReducer(
  state: ReactionListsState = initialState,
  action: ReactionListActions.Actions
): ReactionListsState {
  switch (action.type) {
    case ReactionListActionTypes.SEED_PAGE: {
      const key = createReactionListPageKey(action);
      return {
        ...state,
        pages: {
          ...state.pages,
          [key]: createPageState(toIds(action.reactions), action.hasMore, 'success', action.loadedAt)
        }
      };
    }
    case ReactionListActionTypes.LOAD_PAGE: {
      const key = createReactionListPageKey(action);
      const previous = state.pages[key];
      return {
        ...state,
        pages: {
          ...state.pages,
          [key]: createPageState(previous?.ids || [], previous?.hasMore || false, 'loading', previous?.loadedAt || null)
        }
      };
    }
    case ReactionListActionTypes.LOAD_PAGE_SUCCESS: {
      const key = createReactionListPageKey(action);
      return {
        ...state,
        pages: {
          ...state.pages,
          [key]: createPageState(toIds(action.reactions), action.hasMore, 'success', action.loadedAt)
        }
      };
    }
    case ReactionListActionTypes.LOAD_PAGE_ERROR: {
      const key = createReactionListPageKey(action);
      const previous = state.pages[key];
      return {
        ...state,
        pages: {
          ...state.pages,
          [key]: createPageState(previous?.ids || [], previous?.hasMore || false, 'error', previous?.loadedAt || null)
        }
      };
    }
    case ReactionListActionTypes.ADD_REACTION_TO_LIST: {
      const key = createReactionListPageKey({listType: action.listType, subjectId: action.subjectId, page: 1});
      const previous = state.pages[key];
      if (!previous) {
        return state;
      }

      return {
        ...state,
        pages: {
          ...state.pages,
          [key]: {
            ...previous,
            ids: [action.reaction['@id'], ...previous.ids.filter((id) => id !== action.reaction['@id'])],
            loadedAt: Date.now()
          }
        }
      };
    }
    case ReactionListActionTypes.REMOVE_REACTION_FROM_LIST: {
      const pages = Object.entries(state.pages).reduce((nextPages, [key, pageState]) => {
        const prefix = `${action.listType}::${action.subjectId}::`;
        if (!key.startsWith(prefix)) {
          nextPages[key] = pageState;
          return nextPages;
        }

        nextPages[key] = {
          ...pageState,
          ids: pageState.ids.filter((id) => id !== action.reactionId),
          loadedAt: Date.now()
        };
        return nextPages;
      }, {} as Record<string, ReactionListPageState>);

      return {
        ...state,
        pages
      };
    }
    default:
      return state;
  }
}

